import React from 'react';
import { Provider } from 'react-redux';
import store from '../app/redux/store/store';
import ReactDOM from 'react-dom';
import AppRouter from '../app/react/AppRouter';
import 'materialize-css/dist/js/materialize.min.js';
import Transaction from '../app/models/Transaction';
import transactionCategoryRetriever from "../app/models/services/transactionCategoryRetriever.jsx";
import { startFood } from '../app/redux/food/startFood';
import 'react-toastify/dist/ReactToastify.css';
import '../../css/main.scss';

Transaction.categoryRetrieveCallback = transactionCategoryRetriever;
startFood(store);
$(() => {

	ReactDOM.render(
		<Provider store={store}>
			<AppRouter />
		</Provider>
		,
		document.getElementById('content')
	);
});
